import { render } from "./NewStudentRow.vue?vue&type=template&id=3c57026b&scoped=true"
import script from "./NewStudentRow.vue?vue&type=script&lang=js"
export * from "./NewStudentRow.vue?vue&type=script&lang=js"

import "./NewStudentRow.vue?vue&type=style&index=0&id=3c57026b&lang=scss&scoped=true"

import exportComponent from "/home/misha/Рабочий стол/embody-system-front-admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3c57026b"]])

export default __exports__